import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import {toast} from "react-toastify";
import {Link, useParams} from "react-router-dom";
import CashierAPI from "../../apis/cashierApi/CashierAPI";
import Pagination from "../assets/Pagination";
import TableLoader from "../loaders/TableLoader";
import PrinterCashier from "./PrinterCashier";


const RapportCashOutCDF = () => {

    let {city} = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [accounts, setAccounts] = useState([]);
    const [cashOutsCDF, setCashOutsCDF] = useState([]);
    const [cashOutsCDFNoFiltered, setCashOutsCDFNoFiltered] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");
    const [sources, setSources] = useState([]);


    const fetchRapportCashOutsCDF = async () => {
        try{
            const data =  await CashierAPI.findRapportCashOutsCDF();
            setCashOutsCDF(data);
            setCashOutsCDFNoFiltered(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement du rapport des sorties caisse CDF  !");
        }
    };

    const getCashAccounts = async () => {
        try{
            const data =  await CashierAPI.getCashAccounts();
            setAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };

    const getCashSources = async () => {
        try{
            const data =  await CashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };
    const [param, setSetting] = useState();

    const fetchSetting = async () => {
        try{
            const data =  await CashierAPI.findSetting();
            setSetting(data);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };
    //Au chargement du composant on va chercher les buses
    useEffect(() => {
        fetchRapportCashOutsCDF();
        getCashAccounts();
        fetchSetting();
        getCashSources();
        return () => console.log("Cleanup..");
    },[]);

    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 500;

    const filteredCashOutsCDF = cashOutsCDF.filter(
        t =>
            t.beneficiary.toLowerCase().includes(search.toLowerCase()) ||
            t.motif.toLowerCase().includes(search.toLowerCase()) ||
            t.account.toLowerCase().includes(search.toLowerCase()) ||
            t.source.toLowerCase().includes(search.toLowerCase()) ||
            t.currency.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedCashOutsCDF = Pagination.getData(
        filteredCashOutsCDF,
        currentPage,
        itemsPerPage
    );

    //console.log(allFrets);

    let counter = 1;

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = cashOutsCDF.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setCashOutsCDF(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = cashOutsCDF.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setCashOutsCDF(filtered);
        }else{
            const filtered = cashOutsCDF.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setCashOutsCDF(filtered)
        }

    };

    function calculTotalAllCurrency(data) {
        let totalUSD = 0;
        let totalCDF = 0;
        data.map((d) =>  {
            if (d.currency === "FC"){
                totalCDF += d.amount;
            }else{
                totalUSD += d.amount;
            }
        });
        return {totalUSD, totalCDF}
    }


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h2 className="fw-bold p-2">Rapport de sortie caisse CDF</h2>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <h2 className="card-title">
                                        Total : <b className="text-primary">{cashOutsCDFNoFiltered.length} </b>
                                    </h2>
                                </div>
                                <div className="col">
                                    <h2 className="card-title">
                                        Total avec filtre : <b className="text-success">{paginatedCashOutsCDF ? paginatedCashOutsCDF.length : 0} </b>
                                    </h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Recherche par compte
                                        </label>
                                        <select
                                            className="form-control"
                                            //size={(buses.length)}
                                            name="account"
                                            value={search}
                                            onChange={handleSearch}
                                        >

                                            <option value="">Choisir...</option>
                                            <option value="">TOUS LES COMPTES</option>
                                            {accounts && accounts.map((account) => (
                                                <option key={account.id} value={account.compte}>
                                                    {account.compte}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="source" className="text-dark">Recherche par source</label>
                                    <div className="form-group mt-3">
                                        <select
                                            className="form-control mb-2"
                                            //size={(buses.length)}
                                            name="source"
                                            id="source"
                                            value={search}
                                            onChange={handleSearch}
                                        >

                                            <option value="">Choisir..</option>
                                            <option value="">TOUTES LES SOURCES</option>
                                            {sources && sources.map((account) => (
                                                <option key={account.id} value={account.name}>
                                                    {account.name}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Date debut
                                        </label>
                                        <input type="date" onChange={handleStartedDate} value={startAt}
                                               name="startDate" id="startDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="endDate" className="text-dark">
                                            Date fin
                                        </label>
                                        <input type="date" onChange={handleEndedDate} value={endAt}
                                               name="endDate" id="endDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <button onClick={handleBtns} className="mt-4 btn btn-primary">Filtrer</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 justify-content-end">
                                    <div className="form-group d-flex float-end">
                                        <PrinterCashier devise={"CDF"} param={param} type={"out"} endAt={endAt} startAt={startAt}  critere={search} data={filteredCashOutsCDF} />
                                    </div>
                                </div>
                            </div>

                            <hr/>
                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" colSpan="3">Compte</th>
                                    <th scope="col">Source</th>
                                    <th scope="col">Bénéficiaire</th>
                                    <th scope="col">Motif</th>
                                    <th scope="col">Montant</th>
                                    <th scope="col">Devise</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading &&<tbody>
                                {paginatedCashOutsCDF.map((cashOut) => (
                                    <tr key={cashOut.id}>
                                        <td>{counter++}</td>
                                        <td colSpan="3"><b className="text-primary">{cashOut.account}</b></td>
                                        <td>{cashOut.source}</td>
                                        <td>{cashOut.beneficiary}</td>
                                        <td>{cashOut.motif}</td>
                                        <td><b>{cashOut.amount}</b></td>
                                        <td>{cashOut.currency}</td>
                                        <td>{Moment(cashOut.created_at).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <Link className="btn btn-sm btn-outline-primary mx-1" to={`/cashier/cashOut/edit/${cashOut.id}`}>
                                                <i className="bi bi-pen-fill"></i>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                            {loading && <TableLoader width={300} height={350} />}
                            <div className="invoice-price">
                                <div className="invoice-price-left">
                                    <div className="invoice-price-row">
                                        <div className="sub-price">
                                            {/*<small>SUBTOTAL</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                        <div className="sub-price">
                                            <i className="fa fa-plus text-muted"></i>
                                        </div>
                                        <div className="sub-price">
                                            {/*<small>TAX (5.4%)</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-price-right">
                                    <small>TOTAL</small>
                                    <span className="f-w-600"> {filteredCashOutsCDF && calculTotalAllCurrency(filteredCashOutsCDF).totalCDF > 0 && calculTotalAllCurrency(filteredCashOutsCDF).totalCDF} FC</span>
                                </div>
                            </div>
                            <br/>

                            {itemsPerPage < filteredCashOutsCDF.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredCashOutsCDF.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RapportCashOutCDF;
